import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { CxInteractionFormComponent } from './cx-interaction-form.component';
import { CxInteractionSmartComponent } from './cx-interaction-smart/cx-interaction-smart.component';
import { FormlyModule } from '@ngx-formly/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AlertModule } from 'app/components/alert/alert.module';
import { FormlyCoreModule } from 'ng2-app/form-core/formly/formly-core.module';



@NgModule({
  declarations: [CxInteractionFormComponent, CxInteractionSmartComponent],
  imports: [
    AlertModule,
    CommonModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatCheckboxModule,
    FormlyModule,
  ],
  exports: [CxInteractionFormComponent, CxInteractionSmartComponent]
})
export class CxInteractionSidebarModule { }
